export const en = {
  title: 'My Working Circle',
  titleTooltip: 'Colleagues with whom you work most often',
  addColleague: 'Add colleague',
  addColleagueHint: 'See every profile at the View My Network page',
  remove: 'Remove %{name}',
  empty: 'Add colleagues you work with closely to unlock pair insights',
  viewPairReport: 'View pair report with %{name}',
  searchPlaceholder: 'Search by name or email…',
  searching: 'Searching…',
  adding: 'Adding…',
  colleagueLimitedMemberWarning: "This colleague hasn't upgraded yet and can't be viewed as a pair report.",
  currentUserLimitedMemberWarning: 'Upgrade to Pro to view pair reports.',
  privateProfileError: "This colleague's profile is private. Send them a connection request first.",
  dismiss: 'Dismiss',
}

export const es = en
